import { render, staticRenderFns } from "./unread.vue?vue&type=template&id=db34b27e&scoped=true"
import script from "./unread.vue?vue&type=script&lang=js"
export * from "./unread.vue?vue&type=script&lang=js"
import style0 from "./unread.vue?vue&type=style&index=0&id=db34b27e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db34b27e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db34b27e')) {
      api.createRecord('db34b27e', component.options)
    } else {
      api.reload('db34b27e', component.options)
    }
    module.hot.accept("./unread.vue?vue&type=template&id=db34b27e&scoped=true", function () {
      api.rerender('db34b27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/news/unread.vue"
export default component.exports